<template>
  <div>
    <label>{{label}} <span v-if="required" class="text-danger">*</span> {{label_extra}}</label>
    <draggable
      v-model="images"
      class="mb-3"
      ghost-class="ghost"
      @change="sortOrderImages"
    >
      <transition-group class="row">
        <div v-for="image in images" :key="image" class="col-6 col-md-3 mb-3 draggable">
            <img :src="image" class="w-100" />
            <div
              class="btn btn-danger btn-sm w-100 rounded-0"
              v-on:click="deleteImage(image)"
            >Delete</div>
        </div>
      </transition-group>
    </draggable>
    <input
      class="d-none"
      ref="file"
      type="file"
      @change="uploadImage"
      :multiple="!max_images || max_images > 1"
    />
    <div class="btn btn-secondary btn-sm mb-2" @click="$refs.file.click()">
      <i class="fa fa-upload"></i> Upload images
    </div>
    <div class="font-italic small mb-3">
        *Max {{max_images}} images<br/>
        *Optimal size: {{width}}x{{height}} pixels<br/>
        <!-- *Max file size: {{config.product_image_max_size+'Mb'}}<br/> -->
        *Allowed file extensions: .jpg, .png
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  data() {
    return {
        config: config,
        settings: settings,
        images: images,
        files: [],
        required: required,
        label: label,
        label_extra: label_extra,
        max_images: max_images ? max_images : config.images_max,
        width: width ? width : settings.product_image_width,
        height: height ? height : settings.product_image_height
    };
  },
  methods: {
    deleteImage(image) {
      axios
        .post("/admin/ajax/images/delete", {
          model_id: model_id,
          model: model,
          image: image,
          required: required,
        })
        .catch((error) => {
          this.displayAlert(
            "error",
            "Deletion failed"
          );
        })
        .then((response) => {
          if (response.data.success) {
            this.displayAlert("success", "Image successfully deleted!");
            this.images = response.data.images;
          } else if (response.data.msg) {
            this.displayAlert("error", response.data.msg);
          } else {
            this.displayAlert("error", "Deletion failed");
          }
        });
    },
    sortOrderImages() {
      // send new order ajax
      axios
        .post("/admin/ajax/images/sort", {
            model_id: model_id,
            model: model,
            images: this.images,
        })
        .catch((error) => {
          this.displayAlert(
            "error",
            "Sort order impossible, please try again later or contact us"
          );
        })
        .then((response) => {
          if (response.data.success) {
            this.displayAlert("success", "Images order updated!");
          }
        });
    },
    uploadImage(e) {
      if (!this.$refs.file.files.length) return;
      for (let index = 0; index < this.$refs.file.files.length; index++) {
        var file = this.$refs.file.files[index]
        var FileSize = file.size / 1024 / 1024; // in MiB
        // if (FileSize > config.product_image_max_size) {
        //   this.displayAlert(
        //     "error",
        //     "Error, one of the files you try to upload is over "+config.product_image_max_size+"Mb"
        //   );
        //   return
        // }
      }

      this.displayAlert("info", "Uploading file...");
      // send file ajax
      var formData = new FormData();
      for (var i = 0; i < this.$refs.file.files.length; i++) {
        let file = this.$refs.file.files[i];
        formData.append("images[" + i + "]", file);
      }
      formData.append("model_id", model_id);
      formData.append("model", model);
      formData.append("width", this.width);
      formData.append("height", this.height);
      formData.append("max_images", this.max_images);
      axios
        .post("/admin/ajax/images/upload", formData)
        .catch((error) => {
          this.displayAlert(
            "error",
            "Upload failed"
          );
        })
        .then((response) => {
          if (response.data.success) {
            this.displayAlert("success", "New images added!");
            this.images = response.data.images;
          } else if (!response.data.success) {
            this.displayAlert("error", response.data.msg);
          }
        });
    },
    displayAlert(type, msg) {
        new Noty({
            type: type,
            text: msg,
        }).show()
    },
  },
  mounted() {},
  components: {
    draggable,
  },
};
</script>
